module.exports = __webpack_public_path__ + "img/vertical_7_3_9016.fce95936.png";